import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";

export default function NoteDialog({ showNote, setShowNote }) {
  return (
    <Dialog open={showNote}>
      <DialogTitle>Note</DialogTitle>
      <DialogContent>
        <Box mb={1}>
          <Typography>
            This tool shows you your credit score parameters so that you can identify the strength and weakness of your
            wallet. You have to connect your wallet first!
          </Typography>
        </Box>
        <Box mb={1}>
          <Typography>
            If you <b style={{ color: "#79bf79" }}>hold at least 500 TRAVA</b>, you are able to adjust the parameters to
            monitor how your credit score changes. Based on that, you can devise your own strategy to hold or improve
            your credit score ranks.
          </Typography>
        </Box>
        <Typography>
          The real credit scores might be different, depending on other accumulative and standardized parameters. The
          tool is for recommendation purposes only; you should make your own strategy and have to take all the potential
          risks!
        </Typography>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={() => setShowNote(!showNote)}>
            Ok, i got it!
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
